import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import { BannerKey } from 'src/Libs/banners'
import CloseAction from 'src/Libs/banners/components/BannerCloseAction'
import { BannerCloseType } from 'src/Libs/banners/types'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4, 2, 4),
    alignItems: 'center',
    boxShadow: theme.effectStyles.shadowMain,

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 2, 2, 2),
      gap: theme.spacing(2),
    },
  },
  content: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  infoText: {
    textAlign: 'center',
  },
  button: {
    whiteSpace: 'nowrap',
  },
  closeAction: {
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(2),
    },
  },
}))

interface Props {
  bannerKey: BannerKey
  text: string | React.ReactElement
  closeType: BannerCloseType
  logo: React.ReactElement
  button: React.ReactElement
  onRemoveSuccessMessageKey?: string
  containerStyle?: string
}

/**
 * This component is a promotion banner that can be used to highlight features or to advertise.
 *
 * @beta This component is not yet finalized and might be subject to change.
 * @see {@link 'https://www.figma.com/design/2XkUgderL8Y8WDXHPhUXNJ/E3DC-Component-Catalog?node-id=12-5365&node-type=canvas&t=THRggXi35mMu1E92-0'}
 */
const PromotionBanner: React.FC<Props> = ({ bannerKey, onRemoveSuccessMessageKey, logo, button, text, closeType, containerStyle }) => {
  const { cx, classes } = useStyles()

  return (
    <Paper className={cx(classes.container, containerStyle)}>
      <Box className={classes.content}>
        {logo}
        <Typography variant="body2" className={classes.infoText}>
          {text}
        </Typography>
        <Box className={classes.button}>{button}</Box>
      </Box>
      <Box className={classes.closeAction}>
        <CloseAction closeType={closeType} bannerKey={bannerKey} onRemoveSuccessMessageKey={onRemoveSuccessMessageKey} />
      </Box>
    </Paper>
  )
}

export default PromotionBanner
